import { render, staticRenderFns } from "./BannerInputMedia.vue?vue&type=template&id=946e0360&scoped=true&"
import script from "./BannerInputMedia.vue?vue&type=script&lang=js&"
export * from "./BannerInputMedia.vue?vue&type=script&lang=js&"
import style0 from "./BannerInputMedia.vue?vue&type=style&index=0&id=946e0360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946e0360",
  null
  
)

export default component.exports